import { useNavigate } from "react-router-dom";

function EmployerRegistrationStepFive({
  onDone,
  employerInfo,
}: {
  onDone: Function;
  employerInfo: any;
}) {
  const navigate = useNavigate();

  const handleContinueToLogin = () => {
    localStorage.removeItem("signUpEmployer");
    localStorage.removeItem("employerEmail");
    localStorage.removeItem("mfaReset");
    localStorage.setItem("seekerLogin", "false");
    navigate("/auth/signin");
    onDone?.(employerInfo);
  };

  return (
    <div className="w-full flex flex-col items-center justify-center text-center px-6 py-10">
      <img
        src="/images/employer-signup-success.png"
        alt="Request sent successfully"
        className="w-24 h-24 mb-8"
      />

      <h2 className="text-3xl font-bold text-[#15415E] mb-4">Thank you for registering!</h2>

      <p className="text-base text-gray-500 max-w-md mb-10 leading-relaxed">
      Our team will reach out to complete your account setup. You can continue to log into your account.
      </p>

      <button
        type="button"
        onClick={handleContinueToLogin}
        className="px-10 py-3 text-lg font-semibold text-white bg-[#15415E] rounded-full hover:bg-[#15415E] focus:outline-none"
      >
        Continue to Login
      </button>
    </div>
  );
}

export default EmployerRegistrationStepFive;

/*
import React, { useEffect, useMemo, useState } from "react";

import AuthCode from "react-auth-code-input";

import { useForm } from "react-hook-form";
import { useAuth } from "../../../../providers/auth";
import { friendlyFirebaseError } from "../../../../providers/firebase-errors/friendlyFirebaseError";
import toast from "react-hot-toast";
import ToastAlert from "../../../../components/custom-ui/toast-alert/ToastAlert";
import BuySubscription from "../Components/BuySubscription";
import EmployerTermsPage from "../Components/EmployerTermsPage";
import BillingPage from "../Components/BillingPage";
import PaymentPage from "../Components/PaymentPage";
import ElementsProvider from "../Components/ElementsProvider";
import PurchaseInformationPage from "../Components/PurchaseInformation";

function EmployerRegistrationStepFive({
  onDone,
  employerInfo,
}: {
  onDone: Function;
  employerInfo: any;
}) {
  const auth = useAuth();
  const [currentPlan, setCurrentPlan] = useState("");
  const [promoCodeData, setPromoCodeData] = useState(null);
  const [renderView, setRenderView] = useState();

  // to be removed

  // console.log(employerInfo, "========>employerInfo");

  // const [renderView, setRenderView] = useState(3);
  const handleContinue = (selection: string) => {
    setCurrentPlan(selection);
    setRenderView(1);
    // onDone(slection);
  };

  const handleTerms = (data: any) => {
    setRenderView(2);
    // onDone(slection);
  };

  const handleBilling = (data: any) => {
    setRenderView(3);
    // onDone(data);
  };

  const handlePurchaseInformation = (data: any) => {


    setPromoCodeData(data);
    setRenderView(4);
  };

  const handleBack = () => {
    setRenderView(0)
    // onDone(data);
  };

  const renderSteps = (activeStep: any) => {
    switch (activeStep) {
      case 1:
        return (
          <div className="w-full flex flex-row justify-start my-10">
            <EmployerTermsPage
              onContinue={handleTerms}
              currentPlan={currentPlan}
              employerInfo={employerInfo}
            />
          </div>
        );
      case 2:
        return (
          <div className="w-full h-full flex flex-row justify-start mt-[-15px] ">
            <BillingPage
              onContinue={handleBilling}
              currentPlan={currentPlan}
              employerInfo={employerInfo}
            />
          </div>
        );
      case 3:
        return (
          <div className="w-full  h-full flex flex-row justify-start my-10">
            <PurchaseInformationPage
              onContinue={handlePurchaseInformation}
              currentPlan={currentPlan}
              employerInfo={employerInfo}
            />
          </div>
        );
      case 4:
        return (
          <div className="w-full  h-full flex flex-row justify-start mt-[-30px]">
            <ElementsProvider
              currentPlan={currentPlan}
              priceId={"price_1QPpjfELIBAvshmEI5DonUnt"}
              employerInfo={employerInfo}
              promoCodeData={promoCodeData}
            />
          </div>
        );
      default:
        return (
          <div className="w-full flex flex-row justify-start my-10">
            <BuySubscription onContinue={handleContinue} isSignup={true} />
          </div>
        );
    }
  };

  return <>
    {renderView === 1 && <div>
      <div className="w-full mt-[-37px] flex justify-start">
        <div
          onClick={handleBack}
          className=" cursor-pointer "
        >
          <i className="fa text-xl fa-arrow-left text-instant-teams-blue-Main " aria-hidden="true"></i>
        </div>
      </div>
    </div>}
    {renderSteps(renderView)}
  </>;
}

export default EmployerRegistrationStepFive;
*/
